<template>
  <div>
    <h2 class="mb-4">จัดการคอมเม้นต์</h2>
    <CRow>
      <CCol md="3">
        <CInput
          v-model="word"
          placeholder="ค้นหา"
          @keyup.enter="handleSearch"
        />
      </CCol>
      <CCol md="3">
        <CSelect :value.sync="filterSelected" :options="filter" />
      </CCol>
      <CCol md="6">
        <div class="flex space-between mb-3">
          <CButton color="primary" @click="handleSearch"
            ><i class="fas fa-search"></i> ค้นหา
          </CButton>
          <CButton color="info" @click="handleDownload" :disabled="downloading">
            <i
              :class="
                downloading ? 'fas fa-spinner fa-spin' : 'far fa-file-excel'
              "
            ></i>
            {{ downloading ? 'Downloading...' : 'Excel download' }}
          </CButton>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-good-table
          mode="remote"
          :isLoading.sync="loading"
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: true,
            initialSortBy: defaultSearch.sort
          }"
          @on-sort-change="onSortChange"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'reviewedAt'">
              {{ props.row.reviewedAt | datetimeFormat }}
            </span>
            <span v-else-if="props.column.field == 'action'">
              <CButton
                color="danger"
                variant="outline"
                size="sm"
                class="m-1"
                @click="$refs.deleteModal.show(props.row.id, props.row.comment)"
              >
                <i class="fa fa-trash"></i>
                <span class="sr-only">ลบคอมเม้นต์นี้</span>
              </CButton>
            </span>
            <span v-else class="h6">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-ads-pagination
          :total-items="total"
          :max-visible-pages="5"
          :items-per-page="10"
          :page="search.page"
          :loading="loading"
        >
          <template slot-scope="props">
            <div class="vue-ads-pr-2 vue-ads-leading-loose">
              รายการที่ {{ props.start | decimalFormat }} ถึง
              {{ props.end | decimalFormat }} จาก
              {{ props.total | decimalFormat }} รายการ
            </div>
          </template>
          <template slot="buttons" slot-scope="props">
            <vue-ads-page-button
              v-for="(button, key) in props.buttons"
              :key="key"
              v-bind="button"
              @page-change="pageChange(button.page)"
            />
          </template>
        </vue-ads-pagination>
      </CCol>
    </CRow>

    <DeleteModal ref="deleteModal" :onConfirm="deleteComment" />
  </div>
</template>

<script>
import moment from 'moment'

import DeleteModal from '../modal/DeleteModal'

import apiComment from '@/apis/comment'

export default {
  name: 'Comment',
  components: {
    DeleteModal
  },
  data() {
    return {
      loading: false,
      downloading: false,
      word: '',
      search: {},
      defaultSearch: {
        page: 0,
        limit: 10,
        sort: {
          field: 'updatedAt',
          type: 'asc'
        }
      },
      total: 0,
      filterSelected: 'bookName',
      filter: [
        { value: 'bookName', label: 'ชื่อหนังสือ' },
        { value: 'reviewerName', label: 'ชื่อผู้โพสต์' }
      ],
      columns: [
        {
          label: 'ลำดับ',
          field: 'no',
          width: '50px',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'ข้อความ',
          field: 'comment',
          thClass: 'min-width-250 align-middle',
          tdClass: 'min-width-250'
        },
        {
          label: 'ผู้โพสต์',
          field: 'reviewerName',
          width: '150px'
        },
        {
          label: 'ชื่อหนังสือ',
          field: 'bookName',
          thClass: 'min-width-150 align-middle',
          tdClass: 'min-width-150'
        },
        {
          label: 'คะแนน',
          field: 'score',
          type: 'number',
          width: '100px'
        },
        {
          label: 'วันเวลาที่คอมเม้น',
          field: 'reviewedAt',
          width: '250px'
        },
        {
          field: 'action',
          sortable: false,
          tdClass: 'text-center'
        }
      ],
      rows: []
    }
  },
  created() {
    this.search = Object.assign({}, this.defaultSearch)
  },
  methods: {
    handleSearch() {
      this.search = Object.assign({}, this.defaultSearch)
      if (this.word) this.search[this.filterSelected] = this.word

      this.getList()
    },
    handleDownload() {
      this.downloading = true
      apiComment
        .download()
        .then((data) => {
          const blob = new Blob([data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)

          link.target = '_blank'
          link.download = `${moment().format('YYYYMMDDHHmm')}_comments.csv`
          link.click()
          URL.revokeObjectURL(link.href)

          this.downloading = false
        })
        .catch(() => {
          this.downloading = false
        })
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    onSortChange(params) {
      this.search.sort = params[0]
      this.getList()
    },
    getList() {
      this.loading = true
      apiComment
        .getList(this.search)
        .then((result) => {
          this.total = result.data.totalDocs
          this.rows = []
          for (let i = 0; i < result.data.docs.length; i++) {
            const item = result.data.docs[i]
            this.rows.push({
              no: this.search.page * this.search.limit + i + 1,
              id: item._id,
              comment: item.comment,
              reviewerName: item.user.reviewerName,
              bookName: item.book.name,
              score: item.score,
              reviewedAt: item.reviewedAt
            })
          }
          this.loading = false
        })
        .catch(() => {
          this.rows = []
          this.loading = false
        })
    },
    deleteComment(id) {
      this.loading = true
      apiComment
        .remove(id)
        .then(() => {
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
